
<template>

    <div class="d-flex flex-column flex-column-fluid mb-10 ">
        <div id="kt_app_content" class="app-content  flex-column-fluid ">
            <div id="kt_app_content_container" class="app-container  container-fluid " style="margin-top: 30px!important;">
                <div class="row g-7">
                    <div class="col-lg-3 col-xl-3 col-12 mt-30">
                        <div class="card card-flush">
                        <div class="card-body">
                            <ul class="nav nav-tabs nav-pills nav-fill border-0 flex-column mb-3 mb-md-0 fs-6">
                            <li v-for="(item, index) in menuItems" :key="index" class="nav-item me-0 mt-4">
                                <router-link class="nav-link btn btn-light btn-text-gray-600 btn-icon-gray-600 "  v-if="$can(item.permission)"
                                            :class="[
                            {'active btn-primary': $route.name == item.routeName},
                            {'active btn-primary': item.childRouteName && item.childRouteName.length && item?.childRouteName.includes($route.name)},
                        ]"
                                            :to="{ name: item.routeName }">
                                <div class="d-flex align-items-center justify-content-start ">
                                    <i :class="item.icon" class="m-1" ></i>
                                    <span >{{ $t(item.title) }}</span>
                                </div>
                                </router-link>
                            </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-9 col-xl-9 col-12">
                        <router-view ></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import abilities from "@/composables/abilities";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
export default {
name: "BaseSettingLayout",
components: {},
data() {
    return {
    breadcrumb:  [
        {
             name: 'breadcrumbs.views',
            route: 'nps'
        }
    ],
    menuItems: [
        {
            routeName: 'nps-details',
            title: 'nps.questions',
            icon: 'bi bi-circle-square',
            permission: [],
            childRouteName: ['nps-preview','nps-details']
        },
        {
            routeName: 'nps-responses',
            title: 'nps.responses',
            icon: 'bi bi-circle-square',
            permission: [],
            childRouteName: ['nps-responses-details']

        },
        {
            routeName: 'nps-statistics',
            title: 'nps.statistics',
            icon: 'bi bi-circle-square',
            permission: [abilities.NPS_STATISTIC]
        },
    ],
    }
},
}
</script>

<style scoped>
.btn-primary i{
    color: #FFF !important;
}
</style>
